import $ from 'jquery';
import ImageGallerySlideClass from './ImageGallerySlideClass';
import ThingsManagerClass from '../../libs/base/ThingsManagerClass';

/**
 * ギャラリークラス
 * @example
 * data-targetを監視し、一致する画像URLが書き込まれた場合は、その画像に直接ジャンプ
 */
export default class ImageGalleryClass extends ThingsManagerClass {
  constructor(_target) {
    super();
    this.name = 'ImageGalleryClass';

    this.CL_ACTIVE = 'isActive';

    this.target = _target;

    this.thumsWidth = 100;

    this.isThumClick = false;
  }

  onCreate() {
    this.things = {};

    this.things.images = new ImageGallerySlideClass($('.images', this.target), true);
    this.things.images.on(this.things.images.EVENT_ACTIVE_CHANGE, (e, p) => {
      this.thumsActiveChange(p.index);
      if (this.isThumClick) {
        this.isThumClick = false;
      } else {
        this.onThumsChange(p.index, p.isAnim);
      }
    });

    this.thums = $('.thums ', this.target);
    this.thumsA = $('a', this.thums);

    this.thumsA.on('click', (e) => {
      e.preventDefault();
      this.isThumClick = true;
      const index = this.thumsA.index($(e.currentTarget));
      this.things.images.move(index);
    });

    // data属性の監視
    const observer = new MutationObserver((e) => {
      this.things.images.jump(this.target.attr('data-target'));
    });
    observer.observe(this.target.get(0), { attributes: true });

    super.onCreate();
  }

  onResize(size) {
    super.onResize(size);
    this.thumsWidth = $('li', this.thums).outerWidth();
  }

  onThumsChange(_index, _isAnim) {
    if (_isAnim) {
      this.thums.animate({ scrollLeft: this.thumsWidth * _index }, 300);
    } else {
      this.thums.scrollLeft(this.thumsWidth * _index);
    }
  }

  thumsActiveChange(_index) {
    this.thumsA.removeClass(this.CL_ACTIVE).eq(_index).addClass(this.CL_ACTIVE);
  }
}
